import Repaire from 'elem/SVGIcon/PowerBackup/Repaire';
import CompactAndPortable from 'elem/SVGIcon/PowerBackup/CompactAndPortable';
import Setup from 'elem/SVGIcon/PowerBackup/Setup';
import EFPicture from '@elem/compCommon/EFPicture';
import { submitJoin } from '@elem/Service/delta-pro-ultra';
import css from './index.module.scss';
import { subscribe } from '@/service/vip';
import { useGlobal } from '@/utils/useGlobal';
import { getPagesPrivacyPolicy } from '@/utils/common';

export default function B() {
    const { useLang, useState, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('loadshedding');
    const { locale } = useRouter();
    const [input, setInput] = useState('');
    const [inputVal, setInputVal] = useState('');
    const [check, setCheck] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showMsg, setShowMsg] = useState('');

    const icons: any[] = [
        {
            icon: <Setup />,
            text: t('secB_icon1'),
        },
        {
            icon: <Repaire />,
            text: t('secB_icon2'),
        },
        {
            icon: <CompactAndPortable />,
            text: t('secB_icon3'),
        },
    ];

    const handleInputChange = (v: any) => {
        setInput(v.target.value);
        setInputVal(v.target.value);
    };

    const handleCheck = () => {
        setCheck(!check);
        if (!check && showMsg) {
            setShowMsg('');
        }
        if (check && !showMsg) {
            setShowMsg(t('common_agree_tip'));
        }
    };

    const handleSubmit = async () => {
        const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
        if (!input) {
            return setShowMsg(t('common_email_tip_null'));
        }
        if (!emailRegex.test(input)) {
            return setShowMsg(t('common_email_tip_format'));
        }
        if (!check) {
            return setShowMsg(t('common_agree_tip'));
        }
        try {
            const res = await subscribe(input.trim(), locale, 'WEB_NEW_PRODUCT_SUB', {
                sector_name: t('secB_title'),
                entry_position: '2',
            });

            if (res?.code === '0') {
                setShowModal(true);
                setInput('');
                try {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'activity_submit',
                        button_name: t('secB_email_subscribe'),
                        status: 'success',
                        tag: 'Agree',
                    });
                } catch (e) {
                    console.error(e);
                }
            } else {
                setShowMsg(res?.message);
                console.error(res?.message);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'activity_submit',
                    button_name: t('secB_email_subscribe'),
                    status: 'fail',
                    tag: 'Agree',
                });
            }
        } catch (e) {
            console.error(e);
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_submit',
                button_name: t('secB_email_subscribe'),
                status: 'fail',
                tag: 'Agree',
            });
        }
    };

    const handleJoin = async () => {
        try {
            const res = await submitJoin(locale, { email: inputVal.trim() });
            if (res?.code !== '0') {
                console.log(res?.message);
            }
        } catch (e) {
            console.error(e);
        }
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'activity_join',
                button_name: t('secB_modal_btn'),
            });
        } catch (e) {
            console.error(e);
        }
        return true;
    };

    return (
        <div id="load-shedding-B" className={`load-shedding-B ${css['load-shedding-B']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <h2 className="title">{t('secB_title')}</h2>
                    <p className="desc">{t('secB_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any, k: number) => (
                            <li className="icon" key={k}>
                                {icon?.icon}
                                <p className="icon-text">{icon.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="img-box">
                    <EFPicture
                        src={'/responsive/picture/load-shedding/2.jpg'}
                        srcPad={'/responsive/picture/load-shedding/2_768.jpg'}
                        srcMobile={'/responsive/picture/load-shedding/2_768.jpg'}
                        alt={t('secB_email_title')}
                    />
                    <div className="email-box">
                        <h4 className="email-title">{t('secB_email_title')}</h4>
                        <div className="control">
                            <input type="text" className="input" value={input} onChange={handleInputChange} placeholder={t('secB_email_placeholder')} />
                            <button className="subscribe" onClick={handleSubmit}>
                                {t('secB_email_subscribe')}
                            </button>
                        </div>
                        {showMsg && <p className="error-msg">{showMsg}</p>}
                        <div className="agreement">
                            <input type="checkbox" className="agree-check" id="agree" checked={check} onChange={handleCheck} />
                            <label htmlFor="agree" className="agree-label">
                                {t.rich('secB_email_agreement', {
                                    terms: (text: string) => (
                                        <Link className="link" href={`https://${locale}.ecoflow.com/pages/terms-of-sale`}>
                                            {text}
                                        </Link>
                                    ),
                                    policy: (text: string) => (
                                        <Link className="link" href={getPagesPrivacyPolicy(locale)}>
                                            {text}
                                        </Link>
                                    ),
                                })}
                            </label>
                        </div>
                    </div>
                </div>
                <div className={`modal ${showModal ? 'show' : 'hide'}`}>
                    <div className="modal-content">
                        <span className="close" onClick={() => setShowModal(false)}>
                            &times;
                        </span>
                        <p className="modal-title">{t('common_modal_title')}</p>
                        <p className="modal-text">{t('common_modal_text')}</p>
                        <a
                            href={'https://www.facebook.com/groups/efsouthafrica?utm_source=scenario_page&utm_medium=pillar'}
                            className="modal-btn"
                            target="_blank"
                            onClick={handleJoin}
                            rel="noreferrer"
                        >
                            {t('common_modal_btn')}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
